import React from 'react';
import { useNavigate } from 'react-router-dom';
import RechargeCreditComponent from "../../../components/Customer/credits/RechargeCreditComponent";

const RechargeCreditPage = () => {
    const navigate = useNavigate();

    let redirect = (paymentId) => {
        navigate('/quan-ly-giao-dich/' + paymentId + '/hoan-thanh-yeu-cau-nap-tien.html');
    }

    return <RechargeCreditComponent
        shouldRedirect={ (paymentId) => redirect(paymentId) }
    />;
}

export default RechargeCreditPage;